import EXELIcon from './component'

export default EXELIcon
